module.exports = __webpack_public_path__ + "img/rank.cbd99b0d.png";